import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

export interface TransactionDetailsFilters {
  subsidiary_id?: number | string;
  start_date?: string; // Format: YYYY-MM-DD
  end_date?: string; // Format: YYYY-MM-DD
  account_id?: number | string;
  vendor_id?: number | string;
  customer_id?: number | string;
  reference_type?: string; // e.g., "purchase_order"
  reference_id?: number | string; // For Purchase Order filter
  status?: string; // "draft", "posted", "voided"
  limit?: number;
  offset?: number;
  search?: string;
}

export interface TransactionDetail {
  id: number;
  type: string;
  date: string; // Format: DD-MM-YYYY
  document_no: string;
  name: string;
  memo: string;
  account: string;
  cleared: string; // "Yes" or "No"
  split: string;
  qty: string;
  total_open_bal: number;
  debit?: number;
  credit?: number;
  journal_entry_id?: number;
  journal_number?: string;
  reference_type?: string;
  reference_id?: number;
  account_id?: number;
  entity_id?: number;
}

export interface TransactionDetailsApiResponse {
  status: string;
  message: string;
  data: {
    transactions: TransactionDetail[];
    total: number;
    limit: number;
    offset: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class TransactionDetailsService {
  private readonly API_BASE_URL = environment.accountingUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get transaction details with optional filters
   * Endpoint: GET /api/v1/transactions/details
   */
  getTransactionDetails(filters?: TransactionDetailsFilters): Observable<TransactionDetailsApiResponse> {
    let params = new HttpParams();

    if (filters) {
      if (filters.subsidiary_id !== undefined && filters.subsidiary_id !== null) {
        params = params.set('subsidiary_id', filters.subsidiary_id.toString());
      }

      if (filters.start_date) {
        params = params.set('start_date', filters.start_date);
      }

      if (filters.end_date) {
        params = params.set('end_date', filters.end_date);
      }

      if (filters.account_id !== undefined && filters.account_id !== null) {
        params = params.set('account_id', filters.account_id.toString());
      }

      if (filters.vendor_id !== undefined && filters.vendor_id !== null) {
        params = params.set('vendor_id', filters.vendor_id.toString());
      }

      if (filters.customer_id !== undefined && filters.customer_id !== null) {
        params = params.set('customer_id', filters.customer_id.toString());
      }

      if (filters.reference_type) {
        params = params.set('reference_type', filters.reference_type);
      }

      if (filters.reference_id !== undefined && filters.reference_id !== null) {
        params = params.set('reference_id', filters.reference_id.toString());
      }

      if (filters.status) {
        params = params.set('status', filters.status);
      }

      if (filters.limit !== undefined) {
        params = params.set('limit', filters.limit.toString());
      }

      if (filters.offset !== undefined) {
        params = params.set('offset', filters.offset.toString());
      }

      if (filters.search) {
        params = params.set('search', filters.search);
      }
    }

    return this.http.get<TransactionDetailsApiResponse>(`${this.API_BASE_URL}/api/v1/transactions/details`, {
      params,
      withCredentials: true
    });
  }
}

